<template>
  <div>
    <vs-card id="vendor-details-loading" class="vs-con-loading__container">
      <vs-tabs>
        <vs-tab :label="$tc('vendor') | capitalize" icon-pack="feather" icon="icon-users">
          <div class="tab-text">
            <VendorDetail :vendorId="vendorId"/>
          </div>
        </vs-tab>
        <vs-tab :label="$tc('payday') | capitalize" icon-pack="feather" icon="icon-calendar">
          <div class="tab-text">
            <VendorPaydays  :vendorId="vendorId"/>
          </div>
        </vs-tab>
        <vs-tab :label="$tc('accounts') | capitalize" icon-pack="feather" icon="icon-credit-card">
          <div class="tab-text">
            <VendorAccounts  :vendorId="vendorId" />
          </div>
        </vs-tab>
        <vs-tab :label="$tc('emails') | capitalize" icon-pack="feather" icon="icon-mail">
          <div class="tab-text">
            <VendorEmails :vendorId="vendorId" />
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-card>
  </div>
</template>
<script>
import VendorDetail from './components/VendorDetail.vue';
import VendorPaydays from './components/VendorPaydays.vue';
import VendorAccounts from './components/VendorAccounts.vue';
import VendorEmails from './components/VendorEmails.vue'; 

export default{
  components:{
    VendorDetail,
    VendorPaydays,
    VendorAccounts,
    VendorEmails
  },
  data(){
    return{
      vendorId:''
    }
  },
  mounted(){
    this.vendorId = this.$route.params.id
  }
}
</script>
<style></style>